/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './referral.reducer';

export const Referral = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const referralList = useAppSelector(state => state.referral.entities);
  const loading = useAppSelector(state => state.referral.loading);
  const totalItems = useAppSelector(state => state.referral.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="referral-heading" data-cy="ReferralHeading">
        <Translate contentKey="tinyMedicRestApp.referral.home.title">Referrals</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.referral.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/referral/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.referral.home.createLabel">Create new Referral</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.referral.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {referralList && referralList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.referral.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('referralTypeCode')}>
                  <Translate contentKey="tinyMedicRestApp.referral.referralTypeCode">Referral Type Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralTypeCode')} />
                </th>
                <th className="hand" onClick={sort('referralName')}>
                  <Translate contentKey="tinyMedicRestApp.referral.referralName">Referral Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralName')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.referral.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.referral.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.referral.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.referral.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.referral.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('served')}>
                  <Translate contentKey="tinyMedicRestApp.referral.served">Served</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('served')} />
                </th>
                <th className="hand" onClick={sort('referralNotes')}>
                  <Translate contentKey="tinyMedicRestApp.referral.referralNotes">Referral Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralNotes')} />
                </th>
                <th className="hand" onClick={sort('accepted')}>
                  <Translate contentKey="tinyMedicRestApp.referral.accepted">Accepted</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('accepted')} />
                </th>
                <th className="hand" onClick={sort('rejected')}>
                  <Translate contentKey="tinyMedicRestApp.referral.rejected">Rejected</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rejected')} />
                </th>
                <th className="hand" onClick={sort('rejectNotes')}>
                  <Translate contentKey="tinyMedicRestApp.referral.rejectNotes">Reject Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rejectNotes')} />
                </th>
                <th className="hand" onClick={sort('patientType')}>
                  <Translate contentKey="tinyMedicRestApp.referral.patientType">Patient Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientType')} />
                </th>
                <th className="hand" onClick={sort('exposed')}>
                  <Translate contentKey="tinyMedicRestApp.referral.exposed">Exposed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('exposed')} />
                </th>
                <th className="hand" onClick={sort('sourceAppointmentId')}>
                  <Translate contentKey="tinyMedicRestApp.referral.sourceAppointmentId">Source Appointment Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sourceAppointmentId')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.referral.admission">Admission</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.referral.referredTo">Referred To</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.referral.referredBy">Referred By</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.referral.glucoUser">Gluco User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {referralList.map((referral, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/referral/${referral.id}`} color="link" size="sm">
                      {referral.id}
                    </Button>
                  </td>
                  <td>{referral.referralTypeCode}</td>
                  <td>{referral.referralName}</td>
                  <td>{referral.active ? 'true' : 'false'}</td>
                  <td>{referral.timestampentry}</td>
                  <td>{referral.microSec}</td>
                  <td>{referral.lastupdated}</td>
                  <td>{referral.cursor}</td>
                  <td>{referral.served ? 'true' : 'false'}</td>
                  <td>{referral.referralNotes}</td>
                  <td>{referral.accepted ? 'true' : 'false'}</td>
                  <td>{referral.rejected ? 'true' : 'false'}</td>
                  <td>{referral.rejectNotes}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientType.${referral.patientType}`} />
                  </td>
                  <td>{referral.exposed ? 'true' : 'false'}</td>
                  <td>{referral.sourceAppointmentId}</td>
                  <td>{referral.admission ? <Link to={`/admission/${referral.admission.id}`}>{referral.admission.id}</Link> : ''}</td>
                  <td>{referral.referredTo ? <Link to={`/doctor/${referral.referredTo.id}`}>{referral.referredTo.id}</Link> : ''}</td>
                  <td>{referral.referredBy ? <Link to={`/doctor/${referral.referredBy.id}`}>{referral.referredBy.id}</Link> : ''}</td>
                  <td>{referral.glucoUser ? <Link to={`/gluco-user/${referral.glucoUser.id}`}>{referral.glucoUser.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/referral/${referral.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/referral/${referral.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/referral/${referral.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.referral.home.notFound">No Referrals found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={referralList && referralList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Referral;
